'use strict';

import moment from 'moment';

/**
 * 时间格式化
 * @param time 时间
 * @param format 时间格式
 * @param offset 相对于UTC+8
 * @returns {string}
 */
export default function (time, format, offset) {
  if (!time) {
    return '';
  }
  if (!format) {
    format = 'YYYY-MM-DD';
  }
  if (offset) {
    return moment(time).add(offset, 'hours').format(format);
  }
  return moment(time).format(format);
}



// WEBPACK FOOTER //
// ./src/common/filters/date-format.js